import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import FeaturedVideos from './components/FeaturedVideos';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <CategorySection />
        <FeaturedVideos />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}